/*
 * Zaunkonfigurator 3D – Wizard-UI (Fork des Zaunplaners).
 * Schritt 1 ist ein Verlaufs-Editor: Eckpunkte in der Draufsicht setzen und
 * ziehen, Geländehöhe je Punkt (Gefälle) – daneben eine echte 3D-Vorschau
 * (assets/zaun-3d.js). Schritt 5 zeigt den geplanten Zaun in 3D und bietet
 * die Lieferart "fertig montiert" oder "Bausatz (Einzelteile)" an.
 *
 * Einbindung:
 *   ZaunKonfigurator.init({
 *     container: '#zaun-konfigurator',
 *     daten: window.ZAUN_DATA,          // konfigurator-data.json
 *     adapter: window.ZaunShopifyAdapter // optional; ohne Adapter läuft der Demo-Modus
 *   });
 *
 * Adapter-Schnittstelle:
 *   addToCart(positionen, meta) -> Promise   // legt alles in den Warenkorb
 *   holePreise(positionen)     -> Promise    // optional: Live-Preise nachladen
 *   hinweisText                                // optional: Banner-Text (z. B. Demo-Modus)
 */
(function () {
  'use strict';

  var SCHRITTE = ['Verlauf', 'Modell', 'Höhe', 'Befestigung', 'Ergebnis'];

  function formatEuro(x) {
    return x.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function formatMeter(cm) {
    return (cm / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- Zaunverlauf: Punkte -> Abschnitte ---------- */

  /* geschlossen = Ring: ein zusätzlicher Abschnitt verbindet den letzten Punkt mit dem Start. */
  function segmenteAusPunkten(punkte, geschlossen) {
    var seg = [];
    var n = punkte.length;
    var anzahl = geschlossen && n >= 3 ? n : n - 1;
    for (var i = 0; i < anzahl; i++) {
      var a = punkte[i], b = punkte[(i + 1) % n];
      var laenge = Math.round(Math.hypot(b.x - a.x, b.y - a.y));
      seg.push({ laenge_cm: laenge, hoehen_delta_cm: (b.z || 0) - (a.z || 0) });
    }
    return seg;
  }

  function gesamtLaengeCm(punkte, geschlossen) {
    return segmenteAusPunkten(punkte, geschlossen).reduce(function (a, s) { return a + s.laenge_cm; }, 0);
  }

  /* Feldgruppen ({laengeCm, anzahl}) zu einer flachen Längenliste auflösen. */
  function expandiereFelder(aufteilung) {
    var liste = [];
    (aufteilung && aufteilung.felder || []).forEach(function (g) {
      for (var i = 0; i < g.anzahl; i++) liste.push(g.laengeCm);
    });
    return liste;
  }

  /* ---------- Parametrische SVG-Vorschau ---------- */

  function latteninfo(daten, modell) {
    var info = (daten.latten || []).filter(function (l) { return l.name === modell.latten_name; })[0];
    return info || { breite_cm: 6, anzahl_pro_m: 9, form: 'halbrund' };
  }

  function pfostenfarbe(material) {
    return /rche/i.test(material || '') ? '#c79a55' : '#8a5f33';
  }

  function zeichneZaun(daten, modell, hoeheCm, feldLaengen, querschnittCm, pfostenFarbe) {
    // feldLaengen: Array einzelner Feldlängen in cm, z. B. [250, 250, 230]
    // pfostenFarbe: optional, z. B. Grau für bereits vorhandene Pfosten
    var latte = latteninfo(daten, modell);
    var q = querschnittCm || 9.2;
    var boden = 14;
    var h = hoeheCm + boden + 10;
    var svg = [];
    var x = 0;

    function pfosten() {
      svg.push('<rect x="' + x.toFixed(1) + '" y="' + (h - boden - hoeheCm - 8) +
        '" width="' + q + '" height="' + (hoeheCm + 8) + '" rx="1.5" fill="' + (pfostenFarbe || pfostenfarbe(modell.material)) + '"/>');
      x += q;
    }

    pfosten();
    feldLaengen.forEach(function (fl) {
      svg.push(ZaunSkizze.feld({
        x: x,
        y: h - boden - hoeheCm,
        laengeCm: fl,
        hoeheCm: hoeheCm,
        latte: latte,
        skizze: modell.skizze || {},
        material: modell.material
      }));
      x += fl;
      pfosten();
    });

    var w = x;
    var bodenRect = '<rect x="0" y="' + (h - boden) + '" width="' + w + '" height="' + boden + '" fill="#9aa387" opacity="0.55"/>';
    return '<svg viewBox="0 0 ' + w.toFixed(0) + ' ' + h + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax meet">' +
      bodenRect + svg.join('') + '</svg>';
  }

  /*
   * Erklär-Skizze je Befestigungsart (Schritt 4), nach dem echten IPF-System:
   * Unten im Pfosten ist eine Nut eingefräst, darin liegt ein verzinktes
   * Flacheisen (T-Eisen), das mit 4 Schrauben verschraubt wird. Beim
   * Einbetonieren läuft das Eisen nach unten ins Betonfundament weiter,
   * beim Aufdübeln ist es mit einer Bodenplatte verschweißt, die auf den
   * Untergrund gedübelt wird. "vorhanden" = neues Feld zwischen alten Pfosten.
   * Über befestigung.skizze_typ kann eine neue Option eine der drei Skizzen
   * wiederverwenden, ohne dass hier Code angefasst werden muss.
   */
  function skizzeBefestigung(typ) {
    var holz = '#8a5f33', holzNut = '#6f4b26', stahl = '#4d4d4d',
        beton = '#b8b8b0', betonRand = '#97978f', schraube = '#20201e';
    var gras = '<rect x="0" y="84" width="200" height="5" fill="#9aa387" opacity="0.55"/>';
    var teile = [];

    // Pfosten mit eingefräster Nut, versenktem Flacheisen und 4 Schrauben (2 × 2).
    // yOben/yFuss = Pfosten, eisenBis = unteres Ende des Flacheisens.
    function pfostenMitEisen(yOben, yFuss, eisenBis) {
      var nutOben = yFuss - 52;                                                                          // Nutlänge ≈ Eisenlänge im Pfosten
      var t = '<rect x="86" y="' + yOben + '" width="28" height="' + (yFuss - yOben) + '" rx="2" fill="' + holz + '"/>';
      t += '<rect x="94.5" y="' + nutOben + '" width="11" height="' + (yFuss - nutOben) + '" fill="' + holzNut + '"/>';  // gefräste Nut
      t += '<rect x="96.5" y="' + (nutOben + 2) + '" width="7" height="' + (eisenBis - nutOben - 2) + '" fill="' + stahl + '"/>'; // Flacheisen
      var reihen = [nutOben + 10, nutOben + 26];                                                         // 4 Schrauben im 2×2-Raster
      for (var r = 0; r < reihen.length; r++) {
        t += '<circle cx="98.2" cy="' + reihen[r] + '" r="1.5" fill="' + schraube + '"/>' +
             '<circle cx="101.8" cy="' + reihen[r] + '" r="1.5" fill="' + schraube + '"/>';
      }
      return t;
    }

    if (typ === 'einbetonieren') {
      teile.push(gras);
      teile.push('<rect x="0" y="89" width="200" height="31" fill="#cbbfa8" opacity="0.5"/>');           // Erdreich
      teile.push('<path d="M74,89 L126,89 L119,116 L81,116 Z" fill="' + beton + '" stroke="' + betonRand + '" stroke-width="1"/>'); // Fundament
      teile.push(pfostenMitEisen(8, 78, 111));                                                           // Eisen läuft bis ins Fundament
      teile.push('<path d="M74,89 L126,89 L119,116 L81,116 Z" fill="' + beton + '" opacity="0.75"/>');   // Beton verdeckt das Eisen teilweise
      teile.push('<rect x="96.5" y="89" width="7" height="22" fill="' + stahl + '" opacity="0.35"/>');   // einbetonierter Teil schimmert durch
    } else if (typ === 'aufduebeln') {
      teile.push('<rect x="0" y="94" width="200" height="26" fill="' + beton + '"/>');                   // Fundament/Mauer
      teile.push('<line x1="0" y1="94" x2="200" y2="94" stroke="' + betonRand + '" stroke-width="1.5"/>');
      teile.push('<line x1="42" y1="94" x2="42" y2="120" stroke="' + betonRand + '" stroke-width="1"/>' +
                 '<line x1="158" y1="94" x2="158" y2="120" stroke="' + betonRand + '" stroke-width="1"/>');
      teile.push('<rect x="80" y="93" width="5" height="14" fill="' + stahl + '"/>' +
                 '<rect x="115" y="93" width="5" height="14" fill="' + stahl + '"/>');                   // Schwerlastdübel
      teile.push('<rect x="74" y="89" width="52" height="5" rx="1" fill="' + stahl + '"/>');             // verschweißte Bodenplatte
      teile.push(pfostenMitEisen(4, 84, 89));                                                            // Eisen endet auf der Platte (Schweißnaht)
      teile.push('<path d="M94,89 L96.5,85.5 L103.5,85.5 L106,89 Z" fill="' + stahl + '"/>');            // Schweißnaht Eisen/Platte
      teile.push('<rect x="93" y="84" width="14" height="5" fill="' + stahl + '" opacity="0.55"/>');     // Auflager: Pfosten steht über der Platte
    } else if (typ === 'vorhanden') {
      teile.push(gras);
      teile.push('<rect x="8" y="18" width="15" height="68" rx="1.5" fill="#8d8273"/>' +
                 '<rect x="177" y="18" width="15" height="68" rx="1.5" fill="#8d8273"/>');               // Bestandspfosten
      teile.push(ZaunSkizze.feld({
        x: 27, y: 28, laengeCm: 146, hoeheCm: 58,
        latte: { breite_cm: 9, anzahl_pro_m: 6 },
        skizze: { kopf: 'spitz', spitzeFaktor: 0.9, profil: 'rund', riegel: 'rund' },
        material: 'Fichte KDI'
      }));
      teile.push('<rect x="25" y="22" width="150" height="66" rx="6" fill="none" stroke="#3f6b35" stroke-width="1.5" stroke-dasharray="5 4"/>'); // markiert das neue Feld
    } else {
      return '';
    }

    return '<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">' +
      teile.join('') + '</svg>';
  }

  /*
   * Mini-Skizzen für die Pfostensystem-Auswahl (Schritt 5): zeigen je System
   * den Pfostenfuß bei der gewählten Befestigungsart. IPF nutzt die
   * vorhandene Befestigungs-Skizze (Nut + T-Eisen).
   */
  function skizzePfostensystem(systemId, befestigungId) {
    var aufduebeln = befestigungId === 'aufduebeln';
    if (systemId === 'ipf') return skizzeBefestigung(aufduebeln ? 'aufduebeln' : 'einbetonieren');

    var holz = '#8a5f33', stahl = '#6e6e6e', beton = '#b8b8b0', betonRand = '#97978f', schraube = '#20201e';
    var teile = [];
    // Untergrund wie in den Befestigungs-Skizzen
    if (aufduebeln) {
      teile.push('<rect x="0" y="94" width="200" height="26" fill="' + beton + '"/>');
      teile.push('<line x1="0" y1="94" x2="200" y2="94" stroke="' + betonRand + '" stroke-width="1.5"/>');
    } else {
      teile.push('<rect x="0" y="84" width="200" height="5" fill="#9aa387" opacity="0.55"/>');
      teile.push('<rect x="0" y="89" width="200" height="31" fill="#cbbfa8" opacity="0.5"/>');
      teile.push('<path d="M74,89 L126,89 L119,116 L81,116 Z" fill="' + beton + '" stroke="' + betonRand + '" stroke-width="1"/>');
    }
    var grund = aufduebeln ? 94 : 89;

    if (systemId === 'teisen') {
      // Frontansicht wie die Produkt-Zeichnung 14B: freistehender Stahlpfosten
      // mit zwei angeschweißten Quereisen; die Löcher darin nehmen die
      // Schrauben der Zaunriegel auf.
      teile.push('<rect x="97" y="10" width="7" height="' + (grund - 10 + (aufduebeln ? 0 : 22)) + '" fill="' + stahl + '"/>');
      if (aufduebeln) teile.push('<rect x="76" y="' + (grund - 5) + '" width="48" height="5" rx="1" fill="' + stahl + '"/>');
      [24, 56].forEach(function (y) {
        teile.push('<rect x="81" y="' + y + '" width="38" height="9" rx="2" fill="' + stahl + '"/>');    // Quereisen
        // Schraublöcher an den Enden der Quereisen
        [87, 113].forEach(function (cx) {
          teile.push('<circle cx="' + cx + '" cy="' + (y + 4.5) + '" r="2.2" fill="#fff" stroke="' + schraube + '" stroke-width="1"/>');
        });
      });
    } else { // 'halter': regulärer Vierkantpfosten ohne Nut im Pfostenhalter
      var fuss = aufduebeln ? grund - 4 : 78;
      teile.push('<rect x="86" y="8" width="28" height="' + (fuss - 8) + '" rx="2" fill="' + holz + '"/>');
      if (aufduebeln) teile.push('<rect x="74" y="' + (grund - 5) + '" width="52" height="5" rx="1" fill="' + stahl + '"/>');
      var laschenOben = fuss - 26;
      [83, 111].forEach(function (x) {
        teile.push('<rect x="' + x + '" y="' + laschenOben + '" width="6" height="' +
          (aufduebeln ? fuss - laschenOben : grund - laschenOben + 14) + '" rx="1" fill="' + stahl + '"/>');
        // Schrauben sitzen in den Halter-Laschen (nicht mitten im Holz)
        [8, 18].forEach(function (dy) {
          teile.push('<circle cx="' + (x + 3) + '" cy="' + (laschenOben + dy) + '" r="1.7" fill="' + schraube + '"/>');
        });
      });
    }

    return '<svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">' +
      teile.join('') + '</svg>';
  }

  /* ---------- Share-Link (Konfiguration in der URL) ---------- */

  function stateAusHash(daten) {
    var m = (location.hash || '').match(/zk=([^&]*)/);
    if (!m) return null;
    try {
      var p = new URLSearchParams(decodeURIComponent(m[1]));
      var punkte = null;
      if (p.get('pts')) {
        punkte = p.get('pts').split('~').map(function (t) {
          var k = t.split(',').map(Number);
          return { x: k[0] || 0, y: k[1] || 0, z: k[2] || 0 };
        }).filter(function (q) { return isFinite(q.x) && isFinite(q.y); });
        if (punkte.length < 2) punkte = null;
      } else if (parseFloat(p.get('l'))) {
        // Rückwärtskompatibel zu alten Links mit reiner Länge
        punkte = [{ x: 0, y: 0, z: 0 }, { x: Math.round(parseFloat(p.get('l')) * 100), y: 0, z: 0 }];
      }
      var s = {
        punkte: punkte,
        modellId: p.get('m') || null,
        hoehe_cm: parseInt(p.get('h'), 10) || null,
        befestigungId: p.get('b') || 'einbetonieren',
        lieferartId: p.get('d') || 'vormontiert',
        mitKappen: p.get('k') === '1',
        geschlossen: p.get('c') === '1',
        feldmodus: p.get('fm') === 'mass' ? 'mass' : 'standard',
        massMaxCm: parseInt(p.get('fx'), 10) || null,
        pfostensystem: ['halter', 'teisen'].indexOf(p.get('ps')) >= 0 ? p.get('ps') : 'ipf',
        entfernt: (p.get('x') || '').split(',').filter(Boolean),
        schritt: parseInt(p.get('s'), 10) || 1
      };
      if (s.modellId && !daten.modelle.some(function (mo) { return mo.id === s.modellId; })) s.modellId = null;
      return s;
    } catch (e) { return null; }
  }

  function hashAusState(state) {
    var p = new URLSearchParams();
    if (state.punkte && state.punkte.length >= 2) {
      p.set('pts', state.punkte.map(function (q) {
        return [Math.round(q.x), Math.round(q.y), Math.round(q.z || 0)].join(',');
      }).join('~'));
    }
    if (state.modellId) p.set('m', state.modellId);
    if (state.hoehe_cm) p.set('h', state.hoehe_cm);
    p.set('b', state.befestigungId);
    p.set('d', state.lieferartId || 'vormontiert');
    p.set('k', state.mitKappen ? '1' : '0');
    p.set('c', state.geschlossen ? '1' : '0');
    p.set('fm', state.feldmodus || 'standard');
    if (state.massMaxCm) p.set('fx', state.massMaxCm);
    p.set('ps', state.pfostensystem || 'ipf');
    if (state.entfernt && state.entfernt.length) p.set('x', state.entfernt.join(','));
    p.set('s', state.schritt);
    return '#zk=' + encodeURIComponent(p.toString());
  }

  /* ---------- Demo-Adapter (lokal, ohne Shopify) ---------- */

  function demoAdapter() {
    return {
      hinweisText: 'Demo-Modus: Es wird kein echter Warenkorb befüllt. Preise sind ca.-Preise aus der Stammdaten-DB.',
      addToCart: function (positionen, meta) {
        var zeilen = positionen.map(function (p) {
          return p.menge + ' × ' + p.bezeichnung;
        });
        var payload = {
          items: positionen.map(function (p) {
            return { handle: p.handle, optionen: p.optionen, quantity: p.menge, properties: p.properties };
          })
        };
        zeigeModal(
          '<h3>Warenkorb (Demo)</h3>' +
          '<p><strong>' + esc(meta.zusammenfassung) + '</strong></p>' +
          '<ul>' + zeilen.map(function (z) { return '<li>' + esc(z) + '</li>'; }).join('') + '</ul>' +
          '<p>Summe: <strong>' + formatEuro(meta.summe) + '</strong></p>' +
          '<p>Im Shop würde jetzt folgender <code>cart/add.js</code>-Aufruf abgesetzt:</p>' +
          '<pre>' + esc(JSON.stringify(payload, null, 2)) + '</pre>'
        );
        return Promise.resolve();
      }
    };
  }

  var modalWurzel = null;
  function zeigeModal(html) {
    schliesseModal();
    modalWurzel = document.createElement('div');
    modalWurzel.className = 'zk-modal-hintergrund';
    modalWurzel.innerHTML = '<div class="zk-modal">' + html +
      '<div class="zk-nav"><button type="button" class="zk-btn zk-btn-primaer" data-zk-modal-zu>Schließen</button></div></div>';
    modalWurzel.addEventListener('click', function (e) {
      if (e.target === modalWurzel || e.target.hasAttribute('data-zk-modal-zu')) schliesseModal();
    });
    document.body.appendChild(modalWurzel);
  }
  function schliesseModal() {
    if (modalWurzel) { modalWurzel.remove(); modalWurzel = null; }
  }

  /* Foto-Galerie eines Modells im Modal (echte Produktfotos, blätterbar). */
  function zeigeFotos(modell) {
    var bilder = modell.bilder && modell.bilder.length ? modell.bilder
      : (modell.bild_url ? [modell.bild_url] : []);
    if (!bilder.length) return;
    var idx = 0;
    zeigeModal(
      '<h3>' + esc(modell.name) + '</h3>' +
      '<div class="zk-galerie">' +
      (bilder.length > 1 ? '<button type="button" class="zk-galerie-pfeil" data-galerie="-1" aria-label="Vorheriges Bild">‹</button>' : '') +
      '<img id="zk-galerie-bild" src="' + esc(bilder[0]) + '" alt="Foto: ' + esc(modell.name) + '">' +
      (bilder.length > 1 ? '<button type="button" class="zk-galerie-pfeil" data-galerie="1" aria-label="Nächstes Bild">›</button>' : '') +
      '</div>' +
      (bilder.length > 1 ? '<p class="zk-galerie-stand" id="zk-galerie-stand">Bild 1 von ' + bilder.length + '</p>' : '')
    );
    modalWurzel.querySelector('.zk-modal').classList.add('zk-modal-galerie'); // breiteres Modal für Fotos
    modalWurzel.querySelectorAll('[data-galerie]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        idx = (idx + parseInt(btn.getAttribute('data-galerie'), 10) + bilder.length) % bilder.length;
        modalWurzel.querySelector('#zk-galerie-bild').src = bilder[idx];
        var stand = modalWurzel.querySelector('#zk-galerie-stand');
        if (stand) stand.textContent = 'Bild ' + (idx + 1) + ' von ' + bilder.length;
      });
    });
  }

  /* ---------- Hauptkomponente ---------- */

  function init(opts) {
    var container = typeof opts.container === 'string' ? document.querySelector(opts.container) : opts.container;
    var daten = opts.daten || window.ZAUN_DATA;
    var adapter = opts.adapter || demoAdapter();
    if (!container || !daten || typeof ZaunLogic === 'undefined') {
      if (container) container.innerHTML = '<p>Konfigurator konnte nicht geladen werden (Daten oder Logik fehlen).</p>';
      return;
    }

    var modelle = daten.modelle.slice().sort(function (a, b) { return a.sortierung - b.sortierung; });

    function standardPunkte() {
      return [{ x: 0, y: 0, z: 0 }, { x: 1000, y: 0, z: 0 }];
    }

    var state = stateAusHash(daten) || {
      schritt: 1, punkte: null, modellId: null, hoehe_cm: null,
      befestigungId: 'einbetonieren', lieferartId: 'vormontiert', mitKappen: false, geschlossen: false,
      feldmodus: 'standard', massMaxCm: null, pfostensystem: 'ipf', entfernt: []
    };
    if (!state.entfernt) state.entfernt = [];
    if (!state.pfostensystem) state.pfostensystem = 'ipf';
    if (!state.punkte || state.punkte.length < 2) state.punkte = standardPunkte();
    if (state.punkte.length < 3) state.geschlossen = false;
    // Live-Preise: je Position unveränderlich gecacht; eine Versionsnummer
    // sorgt dafür, dass veraltete Antworten den Zustand nicht überschreiben.
    var livePreiseGeladen = false;
    var livePreise = {};
    var preisAnfrageNr = 0;
    function preisSchluessel(p) {
      return p.handle + '|' + (p.sku || p.bezeichnung);
    }

    // Kamerastände bleiben über Re-Renders erhalten (sonst springt die 3D-Ansicht)
    var kameraMerker = { plan: null, ergebnis: null };
    var planViewer = null;

    function eingaben() {
      return {
        modellId: state.modellId,
        hoehe_cm: state.hoehe_cm,
        befestigungId: state.befestigungId,
        lieferartId: state.lieferartId,
        mitKappen: state.mitKappen,
        geschlossen: state.geschlossen,
        feldmodusId: state.feldmodus,
        mass_max_cm: state.massMaxCm,
        pfostensystemId: state.pfostensystem,
        entfernteTypen: state.entfernt,
        segmente_cm: segmenteAusPunkten(state.punkte, state.geschlossen)
      };
    }

    function ergebnis() {
      if (!state.modellId || !state.hoehe_cm || gesamtLaengeCm(state.punkte, state.geschlossen) <= 0) return null;
      var erg = ZaunLogic.berechneStueckliste(eingaben(), daten);
      // Gecachte Live-Preise über die frisch berechnete Stückliste legen –
      // sonst würde jedes Re-Render die abgerufenen Preise wieder verwerfen.
      if (erg && erg.ok && livePreiseGeladen) {
        var summe = 0, voll = true;
        erg.positionen.forEach(function (p) {
          var lp = livePreise[preisSchluessel(p)];
          if (lp != null) p.einzelpreis = lp;
          if (p.einzelpreis == null) {
            voll = false;
            p.gesamtpreis = null;
          } else {
            p.gesamtpreis = Math.round(p.einzelpreis * p.menge * 100) / 100;
            summe += p.gesamtpreis;
          }
        });
        erg.summe = Math.round(summe * 100) / 100;
        erg.preiseVollstaendig = voll;
      }
      return erg;
    }

    function hoehenFuerModell(modell) {
      var set = {};
      daten.felder.forEach(function (f) {
        if (f.modell === modell.modell_db && f.ausfuehrung === modell.ausfuehrung) set[f.hoehe_cm] = true;
      });
      return Object.keys(set).map(Number).sort(function (a, b) { return a - b; });
    }

    function abPreis(modell) {
      var preise = daten.felder
        .filter(function (f) { return f.modell === modell.modell_db && f.ausfuehrung === modell.ausfuehrung && f.preis != null; })
        .map(function (f) { return Number(f.preis); });
      return preise.length ? Math.min.apply(null, preise) : null;
    }

    function schrittGueltig(n) {
      if (n === 1) {
        var laengeM = gesamtLaengeCm(state.punkte, state.geschlossen) / 100;
        return laengeM >= (daten.grenzen.min_laenge_m || 1) && laengeM <= (daten.grenzen.max_laenge_m || 200);
      }
      if (n === 2) return !!state.modellId;
      if (n === 3) return !!state.hoehe_cm;
      if (n === 4) return !!state.befestigungId;
      return true;
    }

    /* ----- Renderer je Schritt ----- */

    function htmlSchritt1() {
      var segmente = segmenteAusPunkten(state.punkte, state.geschlossen);
      var zeilen = segmente.map(function (s, i) {
        var gefaelle = s.laenge_cm ? Math.abs(s.hoehen_delta_cm) / s.laenge_cm * 100 : 0;
        var istSchluss = state.geschlossen && i === segmente.length - 1;
        return '<tr><td>Abschnitt ' + (i + 1) + (istSchluss ? ' (zurück zum Start)' : '') + '</td>' +
          '<td class="zahl" data-seg-laenge="' + i + '">' + formatMeter(s.laenge_cm) + '</td>' +
          '<td class="zahl" data-seg-gefaelle="' + i + '">' + (gefaelle ? gefaelle.toFixed(1).replace('.', ',') + ' %' : '–') + '</td></tr>';
      }).join('');
      var punktZeilen = state.punkte.map(function (q, i) {
        return '<tr><td>' + (i === 0 ? 'Start' : 'Punkt ' + (i + 1)) + '</td>' +
          '<td class="zahl"><input type="number" class="zk-hoehe-punkt" data-punkt="' + i +
          '" step="5" value="' + Math.round(q.z || 0) + '"> cm</td></tr>';
      }).join('');

      return '<div class="zk-schritt-label">Schritt 1 von 5</div>' +
        '<h2>Plane deinen Zaunverlauf</h2>' +
        '<p class="zk-hilfe">Draufsicht: <strong>Klicken</strong> setzt einen neuen Eckpunkt, <strong>Ziehen</strong> verschiebt ihn, ' +
        '<strong>Doppelklick</strong> löscht ihn. Für einen rundum geschlossenen Zaun klicke am Ende einfach wieder auf den ' +
        '<strong>Startpunkt (S)</strong>. Hanglage? Trage unten die Geländehöhe je Punkt ein – ' +
        'die Felder werden dann gestuft montiert.</p>' +
        '<div class="zk-plan2d"><canvas id="zk-plan-canvas"></canvas></div>' +
        '<div class="zk-plan-werkzeuge">' +
        '<button type="button" class="zk-btn zk-btn-sekundaer" id="zk-punkt-weg">Letzten Punkt entfernen</button>' +
        '<button type="button" class="zk-btn zk-btn-sekundaer" id="zk-plan-reset">Verlauf zurücksetzen</button>' +
        '<label class="zk-plan-schliessen"><input type="checkbox" id="zk-geschlossen"' +
        (state.geschlossen ? ' checked' : '') + (state.punkte.length < 3 ? ' disabled' : '') +
        '> Zaun schließen (Ring)</label>' +
        '<span class="zk-plan-laenge">Gesamtlänge: <strong id="zk-gesamtlaenge">' + formatMeter(gesamtLaengeCm(state.punkte, state.geschlossen)) + '</strong></span>' +
        '</div>' +
        '<div class="zk-plan-tabellen">' +
        '<table class="zk-tabelle zk-tabelle-kompakt"><thead><tr><th>Abschnitt</th><th class="zahl">Länge</th><th class="zahl">Gefälle</th></tr></thead>' +
        '<tbody id="zk-seg-tbody">' + zeilen + '</tbody></table>' +
        '<table class="zk-tabelle zk-tabelle-kompakt"><thead><tr><th>Eckpunkt</th><th class="zahl">Geländehöhe</th></tr></thead>' +
        '<tbody>' + punktZeilen + '</tbody></table>' +
        '</div>' +
        '<h3 class="zk-3d-titel">Vorschau in 3D</h3>' +
        '<div class="zk-3d"><canvas id="zk-3d-plan"></canvas></div>' +
        '<p class="zk-3d-hinweis">Ziehen = drehen · Mausrad/Pinch = zoomen · Shift+Ziehen = verschieben. ' +
        'Modell und Höhe wählst du in den nächsten Schritten – die Vorschau zeigt so lange einen Standard-Zaun ' +
        'in vereinfachter, schematischer Darstellung.</p>';
    }

    function htmlSchritt2() {
      var karten = modelle.map(function (m) {
        var preis = abPreis(m);
        var fotoAnzahl = m.bilder && m.bilder.length ? m.bilder.length : (m.bild_url ? 1 : 0);
        return '<button type="button" class="zk-karte' + (state.modellId === m.id ? ' gewaehlt' : '') +
          '" data-modell="' + m.id + '">' +
          '<div class="zk-karte-bild">' + zeichneZaun(daten, m, 100, [200], 9.2) +
          (m.bild_url ? '<img class="zk-karte-foto" src="' + esc(m.bild_url) + '" alt="Foto: ' + esc(m.name) + '" loading="lazy">' : '') +
          (fotoAnzahl ? '<span class="zk-foto-knopf" data-fotos="' + m.id + '" role="button" tabindex="0" ' +
            'title="Echte Fotos in groß ansehen">📷 ' + fotoAnzahl + ' Foto' + (fotoAnzahl > 1 ? 's' : '') + '</span>' : '') +
          '</div>' +
          '<h3>' + esc(m.name) + '</h3>' +
          '<span class="zk-badge">' + esc(m.material) + '</span>' +
          '<p>' + esc(m.beschreibung) + '</p>' +
          (preis != null ? '<div class="zk-ab-preis">Felder ab ' + formatEuro(preis) + '</div>' : '') +
          '</button>';
      }).join('');
      return '<div class="zk-schritt-label">Schritt 2 von 5</div>' +
        '<h2>Welches Modell gefällt dir?</h2>' +
        '<p class="zk-hilfe">Alle Modelle werden als fertig montierte Zaunfelder geliefert. ' +
        'Beim Überfahren einer Karte erscheint ein echtes Foto – mit 📷 öffnest du alle Fotos in groß.</p>' +
        '<div class="zk-karten">' + karten + '</div>';
    }

    function massMoeglich(modell) {
      return !!(daten.massfeld && typeof FeldLogic !== 'undefined' && daten.parameter &&
        daten.latten_artikel && daten.riegel_artikel && modell && modell.riegel_name);
    }

    function htmlSchritt3() {
      var modell = modelle.filter(function (m) { return m.id === state.modellId; })[0];
      var hoehen = hoehenFuerModell(modell);
      var alle = hoehen.slice();
      if (massMoeglich(modell)) {
        (daten.massfeld.hoehen_cm || []).forEach(function (h) {
          if (alle.indexOf(h) < 0) alle.push(h);
        });
        alle.sort(function (a, b) { return a - b; });
      }
      var knoepfe = alle.map(function (h) {
        var standard = hoehen.indexOf(h) >= 0;
        return '<button type="button" class="zk-segment' + (state.hoehe_cm === h ? ' gewaehlt' : '') +
          '" data-hoehe="' + h + '" data-standard="' + (standard ? '1' : '0') + '">' + h + ' cm' +
          (standard ? '' : '<small class="zk-segment-hinweis">nach Maß</small>') + '</button>';
      }).join('');
      var anfrageBis = daten.grenzen.max_hoehe_auf_anfrage_cm;
      var anfrage = anfrageBis && alle.length && anfrageBis > alle[alle.length - 1]
        ? '<p class="zk-hilfe">Du brauchst mehr als ' + alle[alle.length - 1] + ' cm? Bis ' + anfrageBis +
          ' cm fertigen wir auf Anfrage – ruf uns an oder sende uns deine Konfiguration per „Konfiguration teilen“.</p>'
        : '';
      return '<div class="zk-schritt-label">Schritt 3 von 5</div>' +
        '<h2>Wie hoch soll der Zaun sein?</h2>' +
        '<p class="zk-hilfe">' + esc(modell.name) + ' ist in diesen Höhen erhältlich' +
        (alle.length > hoehen.length ? ' – Höhen mit „nach Maß“ fertigen wir individuell für dich:' : ':') + '</p>' +
        '<div class="zk-segmente">' + knoepfe + '</div>' +
        anfrage;
    }

    function htmlSchritt4() {
      var karten = daten.befestigungen.map(function (b) {
        var bild = skizzeBefestigung(b.skizze_typ || b.id);
        return '<button type="button" class="zk-karte' + (state.befestigungId === b.id ? ' gewaehlt' : '') +
          '" data-befestigung="' + b.id + '">' +
          (bild ? '<div class="zk-karte-bild">' + bild + '</div>' : '') +
          '<h3>' + esc(b.name) + '</h3><p>' + esc(b.beschreibung) + '</p>' +
          (b.details && b.details.length
            ? '<ul class="zk-vorteile">' + b.details.map(function (d) { return '<li>' + esc(d) + '</li>'; }).join('') + '</ul>'
            : '') +
          '</button>';
      }).join('');
      return '<div class="zk-schritt-label">Schritt 4 von 5</div>' +
        '<h2>Wie werden die Pfosten befestigt?</h2>' +
        '<p class="zk-hilfe">Die Skizzen zeigen das Prinzip am Beispiel des IPF-Systems. Welche Pfosten es genau werden ' +
        '(IPF-Systempfosten, T-Eisenpfosten oder regulärer Pfosten mit Halter), wählst du im letzten Schritt – ' +
        'oder du verwendest deine vorhandenen Pfosten weiter.</p>' +
        '<div class="zk-karten">' + karten + '</div>' +
        '<details class="zk-annahmen"><summary>Was ist das IPF-Pfostensystem?</summary>' +
        '<p>Beim IPF-System steht der Holzpfosten nicht im Erdreich: Unten in den Pfosten ist eine Nut eingefräst, ' +
        'in der ein verzinktes T-Eisen versenkt und mit vier Schrauben verschraubt wird – von außen bleibt nur ein ' +
        'schmaler Stahlstreifen sichtbar. Beim <strong>Einbetonieren</strong> wird das untere Ende dieses T-Eisens ' +
        'ins Betonfundament gesetzt, beim <strong>Aufdübeln</strong> ist es mit einer Bodenplatte verschweißt, die ' +
        'auf den festen Untergrund gedübelt wird. In beiden Fällen bleibt zwischen Holz und Boden ein Abstand – ' +
        'Regen- und Spritzwasser können abtrocknen, der Pfosten kann nicht von unten faulen. ' +
        'Das verlängert die Lebensdauer des Zauns deutlich und ist der Grund, warum wir auf Einschlaghülsen verzichten.</p>' +
        '</details>';
    }

    function htmlSchritt5() {
      var erg = ergebnis();
      if (!erg) return '<p class="zk-fehler">Es fehlen noch Angaben – bitte gehe die Schritte durch.</p>';
      if (!erg.ok) {
        return '<div class="zk-fehler"><strong>Das passt noch nicht:</strong><ul>' +
          erg.fehler.map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul></div>';
      }

      var lieferartKarten = (daten.lieferarten || []).map(function (la) {
        return '<button type="button" class="zk-karte zk-karte-klein' + (state.lieferartId === la.id ? ' gewaehlt' : '') +
          '" data-lieferart="' + la.id + '">' +
          '<h3>' + esc(la.name) + '</h3><p>' + esc(la.beschreibung || '') + '</p>' +
          (la.vorteil ? '<div class="zk-ab-preis">' + esc(la.vorteil) + '</div>' : '') +
          '</button>';
      }).join('');

      var zeilen = erg.positionen.map(function (p) {
        var entfernen = p.entfernbar
          ? ' <button type="button" class="zk-pos-entfernen" data-entfernen="' + p.typ +
            '" title="Position entfernen – kannst du auch selbst besorgen">×</button>'
          : '';
        return '<tr><td>' + esc(p.bezeichnung) + entfernen + '</td>' +
          '<td class="zahl">' + p.menge + '</td>' +
          '<td class="zahl">' + (p.einzelpreis != null ? formatEuro(p.einzelpreis) : '–') + '</td>' +
          '<td class="zahl">' + (p.gesamtpreis != null ? formatEuro(p.gesamtpreis) : '–') + '</td></tr>';
      }).join('');

      var entferntNamen = { winkel: 'Zaunwinkel', halter: 'Pfostenhalter' };
      var entferntLeiste = state.entfernt.length
        ? '<div class="zk-entfernt-leiste">Nicht enthalten (besorgst du selbst): ' +
          state.entfernt.map(function (t) {
            return '<button type="button" class="zk-btn zk-btn-sekundaer zk-btn-mini" data-hinzufuegen="' + t + '">+ ' +
              esc(entferntNamen[t] || t) + ' wieder hinzufügen</button>';
          }).join(' ') + '</div>'
        : '';

      var massAktiv = erg.feldmodus === 'mass';
      var massfeldHtml = '';
      if (erg.massVerfuegbar) {
        var maxWert = state.massMaxCm || (daten.massfeld && daten.massfeld.standard_max_cm) || 240;
        var langgutAb = (daten.grenzen && daten.grenzen.langgut_ab_cm) || 240;
        massfeldHtml =
          '<h3 class="zk-abschnitt-titel">Wie lang sollen die Felder sein?</h3>' +
          '<div class="zk-karten zk-karten-2">' +
          '<button type="button" class="zk-karte zk-karte-klein' + (massAktiv ? '' : ' gewaehlt') +
          (erg.hoeheStandard ? '' : '" disabled="disabled') + '" data-feldmodus="standard">' +
          '<h3>Standard-Längen</h3><p>' + (erg.hoeheStandard
            ? 'Felder ab Lager (' + (daten.feldlaengen_cm || []).join('/') + ' cm) – am schnellsten lieferbar. ' +
              'Das letzte Feld je Abschnitt kann vor Ort gekürzt werden.'
            : 'Für ' + state.hoehe_cm + ' cm Zaunhöhe nicht verfügbar – diese Höhe fertigen wir nach Maß.') +
          '</p></button>' +
          '<button type="button" class="zk-karte zk-karte-klein' + (massAktiv ? ' gewaehlt' : '') + '" data-feldmodus="mass">' +
          '<h3>Nach Maß</h3><p>Alle Felder eines Abschnitts gleich lang, individuell gefertigt – ' +
          'ohne Überstand und ohne Kürzen.</p></button>' +
          '</div>' +
          (massAktiv
            ? '<label class="zk-option-zeile zk-mass-zeile"><span><strong>Maximale Feldlänge</strong><br>' +
              '<small>Bis ' + langgutAb + ' cm versenden wir ohne Langgut-Zuschlag – darüber wird der Versand teurer.</small></span>' +
              '<span class="zk-mass-eingabe"><input type="number" id="zk-mass-max" min="' + ((daten.massfeld && daten.massfeld.min_laenge_cm) || 50) +
              '" max="' + ((daten.massfeld && daten.massfeld.max_laenge_cm) || 300) + '" step="5" value="' + maxWert + '"> cm</span></label>'
            : '');
      }

      // Pfostensystem-Auswahl: nur wenn Pfosten mitbestellt werden und mehr als
      // ein System für Modell/Befestigung definiert ist.
      var modellAktuell = modelle.filter(function (m) { return m.id === state.modellId; })[0];
      function systemRegeln(systemId, mitHoehe) {
        return (daten.pfosten_auswahl || []).some(function (r) {
          return (r.system || 'ipf') === systemId && r.befestigung === state.befestigungId &&
            (r.material === '*' || (modellAktuell && r.material === modellAktuell.material)) &&
            (!mitHoehe || (state.hoehe_cm || 0) <= r.bis_hoehe_cm);
        });
      }
      var systemStandard = [
        { id: 'ipf', name: 'IPF-Systempfosten', text: 'Holzpfosten mit gefräster Nut auf T-Eisen bzw. Dübelplatte – kein Erdkontakt, unsere Empfehlung bis 120 cm Zaunhöhe.' },
        { id: 'teisen', name: 'T-Eisenpfosten (Stahl)', text: 'Schlanker Stahlpfosten, feuerverzinkt – die Zaunfelder werden direkt am T-Eisen verschraubt.' },
        { id: 'halter', name: 'Regulärer Pfosten + Halter', text: 'Vierkantpfosten ohne Nut im passenden Pfostenhalter (H-Steg bzw. Dübelplatte) – auch in langen Längen, gut am Hang und bei hohen Zäunen.' }
      ];
      var systemInfos = ((daten.pfostensysteme && daten.pfostensysteme.length) ? daten.pfostensysteme : systemStandard)
        .filter(function (s) { return systemRegeln(s.id, false); });
      var pfostenSystemHtml = '';
      if (!erg.ohnePfosten && systemInfos.length > 1) {
        var karten = systemInfos.map(function (s) {
          var aktiv = erg.pfostensystem === s.id;
          var gesperrt = false, gesperrtText = '';
          if (!systemRegeln(s.id, true)) {
            gesperrt = true;
            gesperrtText = 'Für diese Zaunhöhe nicht verfügbar.';
          } else if (state.pfostensystem === s.id && erg.pfostensystem !== s.id && erg.pfostenSystemAuto === 'stufen') {
            gesperrt = true;
            gesperrtText = 'Für diesen Verlauf nicht verfügbar – die Hang-Stufen brauchen längere Pfosten, als es sie in diesem System gibt.';
          }
          var fotoAnzahl = s.bilder && s.bilder.length ? s.bilder.length : 0;
          return '<button type="button" class="zk-karte zk-karte-klein' + (aktiv ? ' gewaehlt' : '') +
            (gesperrt ? '" disabled="disabled' : '') + '" data-pfostensystem="' + s.id + '">' +
            '<div class="zk-karte-bild">' + skizzePfostensystem(s.id, state.befestigungId) +
            (fotoAnzahl ? '<img class="zk-karte-foto ganz" src="' + esc(s.bilder[0]) + '" alt="Foto: ' + esc(s.name) + '" loading="lazy">' : '') +
            (fotoAnzahl ? '<span class="zk-foto-knopf" data-fotos-system="' + s.id + '" role="button" tabindex="0" ' +
              'title="Echte Fotos in groß ansehen">📷 ' + fotoAnzahl + ' Foto' + (fotoAnzahl > 1 ? 's' : '') + '</span>' : '') +
            '</div>' +
            '<h3>' + s.name + '</h3><p>' + (gesperrt ? gesperrtText : s.text) + '</p></button>';
        }).join('');
        pfostenSystemHtml =
          '<h3 class="zk-abschnitt-titel">Welche Pfosten sollen es sein?</h3>' +
          '<div class="zk-karten">' + karten + '</div>';
      }

      return '<div class="zk-schritt-label">Schritt 5 von 5</div>' +
        '<h2>Dein Zaun: ' + esc(ZaunLogic.zusammenfassung(eingaben(), daten)) + '</h2>' +
        (adapter.hinweisText ? '<div class="zk-hinweise">' + esc(adapter.hinweisText) + '</div>' : '') +
        '<div class="zk-3d zk-3d-gross"><canvas id="zk-3d-ergebnis"></canvas></div>' +
        '<p class="zk-3d-hinweis">Ziehen = drehen · Mausrad/Pinch = zoomen · Shift+Ziehen = verschieben.<br>' +
        'Die 3D-Ansicht ist eine vereinfachte, schematische Darstellung – Details, Farben und Proportionen ' +
        'können vom gelieferten Zaun abweichen. Einen realistischen Eindruck geben die Fotos in der Modellauswahl.</p>' +
        massfeldHtml +
        ((daten.lieferarten || []).length
          ? '<h3 class="zk-abschnitt-titel">Wie sollen die Felder geliefert werden?</h3>' +
            '<div class="zk-karten zk-karten-2">' + lieferartKarten + '</div>'
          : '') +
        pfostenSystemHtml +
        (erg.kappenMoeglich
          ? '<label class="zk-option-zeile"><input type="checkbox" id="zk-kappen"' + (state.mitKappen ? ' checked' : '') + '>' +
            '<span><strong>Pfostenkappen dazulegen</strong><br><small>Optional: Schützen die Pfosten von oben vor Regen.</small></span></label>'
          : '') +
        '<table class="zk-tabelle"><thead><tr><th>Position</th><th class="zahl">Menge</th><th class="zahl">Einzelpreis</th><th class="zahl">Gesamt</th></tr></thead>' +
        '<tbody>' + zeilen + '</tbody>' +
        '<tfoot><tr><td colspan="3">Summe' + (erg.preiseVollstaendig ? '' : ' (unvollständig)') + '</td><td class="zahl">' + formatEuro(erg.summe) + '</td></tr></tfoot></table>' +
        entferntLeiste +
        (erg.hinweise.length ? '<div class="zk-hinweise"><strong>Gut zu wissen:</strong><ul>' +
          erg.hinweise.map(function (h) { return '<li>' + esc(h) + '</li>'; }).join('') + '</ul></div>' : '') +
        '<details class="zk-annahmen"><summary>Vorläufige Annahmen dieser Kalkulation</summary><ul>' +
        (erg.annahmen || []).map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('') + '</ul></details>' +
        '<div class="zk-cta-zeile">' +
        '<button type="button" class="zk-btn zk-btn-primaer" id="zk-warenkorb">Alles in den Warenkorb</button>' +
        '<button type="button" class="zk-btn zk-btn-sekundaer" id="zk-anleitung">Aufbauanleitung</button>' +
        '<button type="button" class="zk-btn zk-btn-sekundaer" id="zk-mail">Per E-Mail speichern</button>' +
        '<button type="button" class="zk-btn zk-btn-sekundaer" id="zk-teilen">Konfiguration teilen</button>' +
        '<button type="button" class="zk-btn zk-btn-sekundaer" id="zk-neustart">Neu starten</button>' +
        '</div>';
    }

    function htmlLeiste() {
      var erg = ergebnis();
      var info = [];
      var laengeCm = gesamtLaengeCm(state.punkte, state.geschlossen);
      var segAnzahl = segmenteAusPunkten(state.punkte, state.geschlossen).length;
      if (laengeCm > 0) {
        info.push(formatMeter(laengeCm) +
          (state.geschlossen ? ' · geschlossen' : segAnzahl > 1 ? ' · ' + segAnzahl + ' Abschnitte' : ''));
      }
      if (erg && erg.ok) {
        info.push(erg.aufteilung.anzahl + ' Felder' + (erg.lieferart === 'bausatz' ? ' (Bausatz)' : ''));
        info.push(erg.pfostenAnzahl + ' Pfosten' + (erg.ohnePfosten ? ' (vorhanden)' : ''));
      }
      var preis = erg && erg.ok
        ? '<div class="zk-leiste-preis">' + formatEuro(erg.summe) +
          '<small>' + (livePreiseGeladen ? 'aktuelle Shop-Preise' : 'ca.-Preis, unverbindlich') + '</small></div>'
        : '<div class="zk-leiste-preis">–</div>';
      return '<div class="zk-leiste-innen"><div class="zk-leiste-info">' + esc(info.join(' · ') || 'Zaunplaner') + '</div>' + preis + '</div>';
    }

    /* ----- Gesamt-Rendering ----- */

    function render() {
      var inhalt;
      if (state.schritt === 1) inhalt = htmlSchritt1();
      else if (state.schritt === 2) inhalt = htmlSchritt2();
      else if (state.schritt === 3) inhalt = htmlSchritt3();
      else if (state.schritt === 4) inhalt = htmlSchritt4();
      else inhalt = htmlSchritt5();

      var progress = SCHRITTE.map(function (_, i) {
        return '<span class="' + (i < state.schritt ? 'aktiv' : '') + '"></span>';
      }).join('');

      var nav = '';
      if (state.schritt < 5) {
        nav = '<div class="zk-nav">' +
          (state.schritt > 1 ? '<button type="button" class="zk-btn zk-btn-sekundaer" id="zk-zurueck">Zurück</button>' : '') +
          '<button type="button" class="zk-btn zk-btn-primaer" id="zk-weiter"' +
          (schrittGueltig(state.schritt) ? '' : ' disabled') + '>Weiter</button></div>';
      } else {
        nav = '<div class="zk-nav"><button type="button" class="zk-btn zk-btn-sekundaer" id="zk-zurueck">Zurück</button></div>';
      }

      container.innerHTML = '<div class="zk"><div class="zk-progress">' + progress + '</div>' +
        inhalt + nav + '<div class="zk-leiste">' + htmlLeiste() + '</div></div>';

      verdrahten();
      try { history.replaceState(null, '', hashAusState(state)); } catch (e) { /* file:// o. ä. */ }

      if (state.schritt === 5 && adapter.holePreise && !livePreiseGeladen) {
        var erg = ergebnis();
        if (erg && erg.ok) {
          var nr = ++preisAnfrageNr;
          adapter.holePreise(erg.positionen).then(function () {
            if (nr !== preisAnfrageNr) return; // veraltete Antwort: Konfiguration hat sich geändert
            erg.positionen.forEach(function (p) {
              if (p.einzelpreis != null) livePreise[preisSchluessel(p)] = p.einzelpreis;
            });
            livePreiseGeladen = true;
            render();
          }).catch(function () { /* ca.-Preise behalten */ });
        }
      }
    }

    function updateLeiste() {
      var leiste = container.querySelector('.zk-leiste');
      if (leiste) leiste.innerHTML = htmlLeiste();
      var weiter = container.querySelector('#zk-weiter');
      if (weiter) weiter.disabled = !schrittGueltig(state.schritt);
    }

    /* ---------- Schritt 1: 2D-Verlaufs-Editor + 3D-Vorschau ---------- */

    /*
     * Baut die 3D-Szene aus dem aktuellen Zustand. Vor der Modellwahl zeigt
     * die Vorschau einen Standard-Zaun (Halbrundlatten, 100 cm).
     * felderProSegment: optional die exakte Aufteilung aus dem Ergebnis;
     * sonst wird sie mit den globalen Feldlängen geschätzt.
     */
    function planSzene(felderProSegment, ohnePfostenFarbe, pfostensystem) {
      var modell = modelle.filter(function (m) { return m.id === state.modellId; })[0];
      var latte = modell ? latteninfo(daten, modell) : { breite_cm: 6.4, anzahl_pro_m: 9 };

      // Sichtbare Haltetechnik vorerst deaktiviert (gefiel optisch nicht);
      // der Renderer unterstützt plan.halterung weiterhin – bei Bedarf hier
      // wieder aus Befestigung + Pfostensystem ableiten.
      var halterung = null;
      var aktPfostensystem = pfostensystem || state.pfostensystem || 'ipf';
      var feldlaengen = daten.feldlaengen_cm || [200, 230, 250];
      if (!felderProSegment) {
        var langgutAb = (daten.grenzen && daten.grenzen.langgut_ab_cm) || null;
        felderProSegment = segmenteAusPunkten(state.punkte, state.geschlossen).map(function (s) {
          return expandiereFelder(ZaunLogic.feldAufteilung(s.laenge_cm, feldlaengen, langgutAb));
        });
      }
      // Beim Ring bekommt die Szene den Startpunkt noch einmal ans Ende,
      // damit der Schluss-Abschnitt mitgezeichnet wird.
      var szenePunkte = state.geschlossen && state.punkte.length >= 3
        ? state.punkte.concat([state.punkte[0]])
        : state.punkte;
      return Zaun3D.szeneAusPlan({
        punkte: szenePunkte,
        hoeheCm: state.hoehe_cm || 100,
        latte: latte,
        skizze: modell ? modell.skizze : {},
        felderProSegment: felderProSegment,
        material: modell ? modell.material : 'Fichte KDI',
        pfostenFarbe: ohnePfostenFarbe ? '#8d8273' : null,
        pfostensystem: aktPfostensystem,
        befestigungId: state.befestigungId,
        halterung: halterung,
        pfostenTyp: !ohnePfostenFarbe && (pfostensystem || state.pfostensystem) === 'teisen' ? 'teisen' : 'holz',
        // Bausatz am Hang wird schräg montiert (Latten "im Wasser", keine Stufen)
        schraeg: state.lieferartId === 'bausatz'
      });
    }

    function planEditorVerdrahten() {
      var canvas2d = container.querySelector('#zk-plan-canvas');
      var canvas3d = container.querySelector('#zk-3d-plan');
      if (!canvas2d || !canvas3d) { planViewer = null; return; }

      var ctx = canvas2d.getContext('2d');
      var sicht = { skala: 1, ox: 0, oy: 0, dpr: 1 };
      var dragIdx = -1;
      var bewegt = false;

      function weltZuBild(q) { return [sicht.ox + q.x * sicht.skala, sicht.oy + q.y * sicht.skala]; }
      function bildZuWelt(sx, sy) {
        return { x: (sx - sicht.ox) / sicht.skala, y: (sy - sicht.oy) / sicht.skala };
      }
      function raste(v) { return Math.round(v / 10) * 10; } // auf 10 cm

      function zeichnePlan() {
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        sicht.dpr = dpr;
        canvas2d.width = Math.round(canvas2d.clientWidth * dpr);
        canvas2d.height = Math.round(canvas2d.clientHeight * dpr);
        var w = canvas2d.width, h = canvas2d.height;

        // Weltausschnitt: alle Punkte + Rand, mindestens 8 × 6 m
        var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        state.punkte.forEach(function (q) {
          minX = Math.min(minX, q.x); maxX = Math.max(maxX, q.x);
          minY = Math.min(minY, q.y); maxY = Math.max(maxY, q.y);
        });
        minX -= 150; maxX += 150; minY -= 150; maxY += 150;
        if (maxX - minX < 800) { var cx = (maxX + minX) / 2; minX = cx - 400; maxX = cx + 400; }
        if (maxY - minY < 500) { var cy = (maxY + minY) / 2; minY = cy - 250; maxY = cy + 250; }
        sicht.skala = Math.min(w / (maxX - minX), h / (maxY - minY));
        sicht.ox = w / 2 - (minX + maxX) / 2 * sicht.skala;
        sicht.oy = h / 2 - (minY + maxY) / 2 * sicht.skala;

        ctx.clearRect(0, 0, w, h);

        // Meter-Raster
        ctx.lineWidth = 1;
        for (var gx = Math.ceil(minX / 100) * 100; gx <= maxX; gx += 100) {
          ctx.strokeStyle = gx % 500 === 0 ? 'rgba(90,85,70,0.28)' : 'rgba(90,85,70,0.12)';
          ctx.beginPath();
          ctx.moveTo(sicht.ox + gx * sicht.skala, 0); ctx.lineTo(sicht.ox + gx * sicht.skala, h);
          ctx.stroke();
        }
        for (var gy = Math.ceil(minY / 100) * 100; gy <= maxY; gy += 100) {
          ctx.strokeStyle = gy % 500 === 0 ? 'rgba(90,85,70,0.28)' : 'rgba(90,85,70,0.12)';
          ctx.beginPath();
          ctx.moveTo(0, sicht.oy + gy * sicht.skala); ctx.lineTo(w, sicht.oy + gy * sicht.skala);
          ctx.stroke();
        }

        // Zaunlinie mit Längen-Beschriftung
        ctx.strokeStyle = '#3f6b35';
        ctx.lineWidth = 3 * dpr;
        ctx.lineJoin = 'round';
        ctx.beginPath();
        state.punkte.forEach(function (q, i) {
          var b = weltZuBild(q);
          if (i === 0) ctx.moveTo(b[0], b[1]); else ctx.lineTo(b[0], b[1]);
        });
        if (state.geschlossen && state.punkte.length >= 3) ctx.closePath();
        ctx.stroke();

        // Offener Verlauf mit ≥ 3 Punkten: gestrichelte Hilfslinie zeigt,
        // dass ein Klick auf den Startpunkt den Zaun schließt.
        if (!state.geschlossen && state.punkte.length >= 3) {
          var vonB = weltZuBild(state.punkte[state.punkte.length - 1]);
          var zuB = weltZuBild(state.punkte[0]);
          ctx.save();
          ctx.strokeStyle = 'rgba(63,107,53,0.45)';
          ctx.lineWidth = 2 * dpr;
          ctx.setLineDash([6 * dpr, 6 * dpr]);
          ctx.beginPath();
          ctx.moveTo(vonB[0], vonB[1]);
          ctx.lineTo(zuB[0], zuB[1]);
          ctx.stroke();
          ctx.restore();
        }

        ctx.font = (11 * dpr) + 'px sans-serif';
        ctx.textAlign = 'center';
        var segAnzahl = state.geschlossen && state.punkte.length >= 3 ? state.punkte.length : state.punkte.length - 1;
        for (var i = 0; i < segAnzahl; i++) {
          var p0 = state.punkte[i];
          var p1 = state.punkte[(i + 1) % state.punkte.length];
          var a = weltZuBild(p0);
          var b2 = weltZuBild(p1);
          var laenge = Math.hypot(p1.x - p0.x, p1.y - p0.y);
          var nx = -(b2[1] - a[1]), ny = b2[0] - a[0];
          var nl = Math.hypot(nx, ny) || 1;
          var tx = (a[0] + b2[0]) / 2 + nx / nl * 16 * dpr;
          var ty = (a[1] + b2[1]) / 2 + ny / nl * 16 * dpr + 4 * dpr;
          // Heller Halo, damit die Zaunlinie (z. B. bei Ecken oder waagerechten
          // Abschnitten) die Beschriftung nie verdeckt ("1,50 m" statt "50 m").
          ctx.strokeStyle = 'rgba(255, 255, 255, 0.92)';
          ctx.lineWidth = 4 * dpr;
          ctx.lineJoin = 'round';
          ctx.strokeText(formatMeter(laenge), tx, ty);
          ctx.fillStyle = '#2b2b28';
          ctx.fillText(formatMeter(laenge), tx, ty);
        }

        // Eckpunkte
        state.punkte.forEach(function (q, i) {
          var b3 = weltZuBild(q);
          ctx.beginPath();
          ctx.arc(b3[0], b3[1], 8 * dpr, 0, Math.PI * 2);
          ctx.fillStyle = i === dragIdx ? '#3f6b35' : '#ffffff';
          ctx.fill();
          ctx.strokeStyle = '#3f6b35';
          ctx.lineWidth = 2 * dpr;
          ctx.stroke();
          ctx.fillStyle = i === dragIdx ? '#ffffff' : '#3f6b35';
          ctx.fillText(i === 0 ? 'S' : String(i + 1), b3[0], b3[1] + 4 * dpr);
        });
      }

      function plan3dAktualisieren(anpassen) {
        if (planViewer) planViewer.setzeSzene(planSzene(null, istOhnePfosten()), anpassen);
      }

      function istOhnePfosten() {
        var b = (daten.befestigungen || []).filter(function (x) { return x.id === state.befestigungId; })[0];
        return !!(b && b.ohne_pfosten);
      }

      /* Leichte Aktualisierung während des Ziehens (kein Re-Render, Fokus bleibt). */
      function planLeichtAktualisieren() {
        zeichnePlan();
        plan3dAktualisieren(false);
        var segmente = segmenteAusPunkten(state.punkte, state.geschlossen);
        segmente.forEach(function (s, i) {
          var zelleL = container.querySelector('[data-seg-laenge="' + i + '"]');
          var zelleG = container.querySelector('[data-seg-gefaelle="' + i + '"]');
          if (zelleL) zelleL.textContent = formatMeter(s.laenge_cm);
          if (zelleG) {
            var g = s.laenge_cm ? Math.abs(s.hoehen_delta_cm) / s.laenge_cm * 100 : 0;
            zelleG.textContent = g ? g.toFixed(1).replace('.', ',') + ' %' : '–';
          }
        });
        var gesamt = container.querySelector('#zk-gesamtlaenge');
        if (gesamt) gesamt.textContent = formatMeter(gesamtLaengeCm(state.punkte, state.geschlossen));
        livePreiseGeladen = false; livePreise = {};
        updateLeiste();
      }

      function punktBei(sx, sy) {
        for (var i = 0; i < state.punkte.length; i++) {
          var b = weltZuBild(state.punkte[i]);
          if (Math.hypot(b[0] - sx, b[1] - sy) < 14 * sicht.dpr) return i;
        }
        return -1;
      }

      function ereignisPos(e) {
        var r = canvas2d.getBoundingClientRect();
        return [(e.clientX - r.left) * sicht.dpr, (e.clientY - r.top) * sicht.dpr];
      }

      canvas2d.style.touchAction = 'none';
      canvas2d.addEventListener('pointerdown', function (e) {
        var p = ereignisPos(e);
        dragIdx = punktBei(p[0], p[1]);
        bewegt = false;
        if (dragIdx >= 0) canvas2d.setPointerCapture(e.pointerId);
        zeichnePlan();
      });
      canvas2d.addEventListener('pointermove', function (e) {
        if (dragIdx < 0) return;
        var p = ereignisPos(e);
        var w = bildZuWelt(p[0], p[1]);
        state.punkte[dragIdx].x = raste(w.x);
        state.punkte[dragIdx].y = raste(w.y);
        bewegt = true;
        planLeichtAktualisieren();
      });
      canvas2d.addEventListener('pointerup', function () {
        if (dragIdx >= 0 && bewegt) {
          try { history.replaceState(null, '', hashAusState(state)); } catch (e2) { /* file:// */ }
        }
        dragIdx = -1;
        zeichnePlan();
      });
      canvas2d.addEventListener('click', function (e) {
        if (bewegt) return; // war ein Zieh-Vorgang
        var p = ereignisPos(e);
        var idx = punktBei(p[0], p[1]);
        if (idx === 0 && !state.geschlossen && state.punkte.length >= 3) {
          // Klick auf den Startpunkt schließt den Zaun zum Ring
          state.geschlossen = true;
          render();
          return;
        }
        if (idx >= 0) return;
        var w = bildZuWelt(p[0], p[1]);
        var letzter = state.punkte[state.punkte.length - 1];
        state.punkte.push({ x: raste(w.x), y: raste(w.y), z: letzter.z || 0 });
        render(); // neue Punktzeile in der Tabelle
      });
      canvas2d.addEventListener('dblclick', function (e) {
        var p = ereignisPos(e);
        var idx = punktBei(p[0], p[1]);
        if (idx >= 0 && state.punkte.length > 2) {
          state.punkte.splice(idx, 1);
          if (state.punkte.length < 3) state.geschlossen = false;
          render();
        }
      });

      container.querySelectorAll('.zk-hoehe-punkt').forEach(function (input) {
        input.addEventListener('input', function () {
          var i = parseInt(input.getAttribute('data-punkt'), 10);
          state.punkte[i].z = parseFloat(input.value) || 0;
          planLeichtAktualisieren();
        });
      });

      var punktWeg = container.querySelector('#zk-punkt-weg');
      if (punktWeg) punktWeg.addEventListener('click', function () {
        if (state.punkte.length > 2) {
          state.punkte.pop();
          if (state.punkte.length < 3) state.geschlossen = false;
          render();
        }
      });
      var reset = container.querySelector('#zk-plan-reset');
      if (reset) reset.addEventListener('click', function () {
        state.punkte = standardPunkte();
        state.geschlossen = false;
        kameraMerker.plan = null;
        render();
      });
      var geschlossenBox = container.querySelector('#zk-geschlossen');
      if (geschlossenBox) geschlossenBox.addEventListener('change', function () {
        state.geschlossen = geschlossenBox.checked && state.punkte.length >= 3;
        livePreiseGeladen = false; livePreise = {};
        render();
      });

      // 3D-Vorschau aufbauen; Kamerastand über Re-Renders hinweg behalten
      planViewer = Zaun3D.erstelle(canvas3d);
      planViewer.setzeSzene(planSzene(null, istOhnePfosten()), !kameraMerker.plan);
      if (kameraMerker.plan) {
        planViewer.kamera.theta = kameraMerker.plan.theta;
        planViewer.kamera.phi = kameraMerker.plan.phi;
        planViewer.kamera.dist = kameraMerker.plan.dist;
        planViewer.kamera.ziel = kameraMerker.plan.ziel.slice();
        planViewer.render();
      }
      kameraMerker.plan = planViewer.kamera;

      zeichnePlan();
    }

    /* ---------- Individuelle Aufbauanleitung (druckfertige Seite) ---------- */

    /*
     * Pfosten-Plan: je Abschnitt die Feldfolge und alle Pfostenpositionen
     * (cm ab Abschnittsanfang) mit durchlaufender Nummer. Geteilte Eckpfosten
     * behalten ihre Nummer; die Nummern passen zu erg.pfostenDetails.
     */
    function pfostenPlan(erg) {
      var geschlossen = state.geschlossen && state.punkte.length >= 3;
      var global = 0;
      var abschnitte = [];
      erg.aufteilung.proSegment.forEach(function (a, i) {
        var felderListe = expandiereFelder(a);
        var L = erg.segmente[i].laenge_cm;
        var summe = felderListe.reduce(function (x, y) { return x + y; }, 0);
        if (summe > L && felderListe.length) {
          felderListe[felderListe.length - 1] -= (summe - L); // letztes Feld wird vor Ort gekürzt
        }
        var posn = [];
        var s = 0;
        for (var k = 0; k <= felderListe.length; k++) {
          var nummer;
          if (k === 0) nummer = (i === 0) ? ++global : global;
          else if (k === felderListe.length && geschlossen && i === erg.aufteilung.proSegment.length - 1) nummer = 1;
          else nummer = ++global;
          posn.push({ nummer: nummer, sCm: Math.round(s) });
          if (k < felderListe.length) s += felderListe[k];
        }
        abschnitte.push({ felder: felderListe, pfosten: posn, laengeCm: L });
      });
      return abschnitte;
    }

    /* Draufsicht als SVG für den Druck: Verlauf, Längen, Pfostenpositionen. */
    function planSvgFuerDruck(plan) {
      var pts = state.punkte;
      var geschlossen = state.geschlossen && pts.length >= 3;
      var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      pts.forEach(function (q) {
        minX = Math.min(minX, q.x); maxX = Math.max(maxX, q.x);
        minY = Math.min(minY, q.y); maxY = Math.max(maxY, q.y);
      });
      minX -= 90; maxX += 90; minY -= 70; maxY += 70;
      if (maxX - minX < 400) { var cx = (minX + maxX) / 2; minX = cx - 200; maxX = cx + 200; }
      if (maxY - minY < 260) { var cy = (minY + maxY) / 2; minY = cy - 130; maxY = cy + 130; }
      var svg = [];
      var segAnzahl = geschlossen ? pts.length : pts.length - 1;
      var textHalo = ' style="paint-order:stroke" stroke="#fff" stroke-width="6" font-family="sans-serif" fill="#2b2b28"';

      for (var i = 0; i < segAnzahl; i++) {
        var p0 = pts[i], p1 = pts[(i + 1) % pts.length];
        svg.push('<line x1="' + p0.x + '" y1="' + p0.y + '" x2="' + p1.x + '" y2="' + p1.y +
          '" stroke="#3f6b35" stroke-width="5" stroke-linecap="round"/>');
        var laenge = Math.hypot(p1.x - p0.x, p1.y - p0.y);
        if (laenge < 1) continue;
        var ex = (p1.x - p0.x) / laenge, ey = (p1.y - p0.y) / laenge;
        var nx = -ey, ny = ex;
        svg.push('<text x="' + ((p0.x + p1.x) / 2 + nx * 26) + '" y="' + ((p0.y + p1.y) / 2 + ny * 26 + 6) +
          '" text-anchor="middle" font-size="20"' + textHalo + '>' + formatMeter(laenge) + '</text>');

        // Pfostenmarken mit Nummern; geteilte Eckpfosten (Anfangspfosten der
        // Folgeabschnitte, Ringschluss) nur einmal beschriften
        (plan[i] ? plan[i].pfosten : []).forEach(function (pf, pfIdx) {
          var liste = plan[i].pfosten;
          if (i > 0 && pfIdx === 0) return;
          if (geschlossen && i === segAnzahl - 1 && pfIdx === liste.length - 1) return;
          var px = p0.x + ex * pf.sCm, py = p0.y + ey * pf.sCm;
          svg.push('<rect x="' + (px - 6) + '" y="' + (py - 6) + '" width="12" height="12" fill="#8a5f33" stroke="#fff" stroke-width="2"/>');
          svg.push('<text x="' + (px - nx * 24) + '" y="' + (py - ny * 24 + 5) +
            '" text-anchor="middle" font-size="15"' + textHalo + '>P' + pf.nummer + '</text>');
        });
      }
      pts.forEach(function (q, i2) {
        if (i2 === 0) {
          svg.push('<circle cx="' + q.x + '" cy="' + q.y + '" r="10" fill="#3f6b35"/>');
          svg.push('<text x="' + q.x + '" y="' + (q.y + 5) + '" text-anchor="middle" font-size="13" fill="#fff" font-family="sans-serif">S</text>');
        }
      });
      return '<svg viewBox="' + minX + ' ' + minY + ' ' + (maxX - minX) + ' ' + (maxY - minY) +
        '" xmlns="http://www.w3.org/2000/svg" style="width:100%;max-height:420px;background:#f7f5f0;border-radius:8px">' +
        svg.join('') + '</svg>';
    }

    /* Montage-Textbausteine (ENTWURF – fachliche Prüfung steht aus, siehe offene Punkte). */
    function montageSchritte(erg) {
      var b = state.befestigungId;
      var sys = erg.pfostensystem;
      var bausatz = erg.lieferart === 'bausatz';
      var schraeg = erg.schraegMontage;
      var s = [];

      s.push({ t: 'Vorbereitung', p: [
        'Zaunverlauf mit Schnur und Pflöcken abstecken. Die Maßkette in dieser Anleitung nennt für jeden Pfosten (P1, P2, …) die Position ab dem Anfang des jeweiligen Abschnitts – Positionen am Boden markieren.',
        'Lieferung anhand der Stückliste prüfen, Werkzeug bereitlegen (Liste unten).'
      ]});

      if (erg.ohnePfosten) {
        s.push({ t: 'Vorhandene Pfosten prüfen', p: [
          'Prüfe, ob deine Pfosten fest verankert, lotrecht und mindestens so hoch wie der neue Zaun sind.',
          'Miss die lichten Weiten zwischen den Pfosten nach – das letzte Feld je Abschnitt kann vor Ort gekürzt werden.'
        ]});
      } else if (b === 'einbetonieren') {
        var setzen = [
          'Löcher an den markierten Positionen ausheben (Richtwert: ca. 40 × 40 cm, ca. 60 cm tief – frostfrei gründen).',
          sys === 'teisen'
            ? 'T-Eisenpfosten lotrecht einsetzen und einbetonieren; Höhe an der Schnur ausrichten.'
            : (sys === 'halter'
              ? 'H-Steg-Pfostenträger lotrecht einbetonieren; die Pfosten werden später in die Träger gestellt und seitlich verschraubt.'
              : 'T-Eisen der IPF-Pfosten lotrecht einbetonieren; die Pfosten werden später aufgesetzt (Eisen sitzt in der gefrästen Nut) und mit vier Schrauben fixiert.'),
          'Beton aushärten lassen (Richtwert: 1–2 Tage, je nach Produktangabe), erst dann die Felder montieren.'
        ];
        s.push({ t: 'Pfosten setzen (Einbetonieren)', p: setzen });
      } else if (b === 'aufduebeln') {
        s.push({ t: 'Pfosten setzen (Aufdübeln)', p: [
          'Positionen auf dem tragfähigen Untergrund (Fundament, Mauerkrone) anzeichnen, Bohrlöcher setzen.',
          sys === 'teisen'
            ? 'Fußplatten der T-Eisenpfosten mit Schwerlastdübeln festschrauben, Pfosten lotrecht ausrichten.'
            : (sys === 'halter'
              ? 'Dübelplatten-Halter mit Schwerlastdübeln festschrauben; Pfosten einstellen, ausrichten und seitlich verschrauben.'
              : 'Dübelplatten der IPF-Pfosten mit Schwerlastdübeln festschrauben; Pfosten aufsetzen (T-Eisen in der Nut) und mit vier Schrauben fixieren.')
        ]});
      }

      if (!erg.ohnePfosten || true) {
        var montage = [];
        if (bausatz) {
          montage.push('Riegel auf Höhe ausrichten und befestigen' +
            (sys === 'teisen' ? ' – an den Quereisen der T-Eisenpfosten verschrauben.' :
              ' – mit den Zaunwinkeln an den Pfosten verschrauben.'));
          if (schraeg) {
            montage.push('Am Hang: Riegel dem Geländeverlauf folgend montieren; die Latten anschließend senkrecht („im Wasser“) anschrauben – ein gleichmäßiger Abstandsklotz hilft.');
          } else {
            montage.push('Latten senkrecht mit gleichmäßigem Abstand anschrauben – eine Abstandslehre (Holzklotz) hilft.');
          }
        } else {
          montage.push(sys === 'teisen'
            ? 'Fertige Felder ansetzen und die Riegel direkt an den Quereisen der T-Eisenpfosten verschrauben – die Felder stoßen dabei direkt aneinander.'
            : 'Fertige Felder zwischen die Pfosten setzen und die Riegel mit den Zaunwinkeln an den Pfosten verschrauben.');
          if (erg.maxStufeCm > 0) {
            montage.push('Am Hang die Felder waagerecht ausrichten (Wasserwaage) und dem Gelände folgend stufen – größte Stufe hier ca. ' + erg.maxStufeCm + ' cm.');
          }
          montage.push('Letztes Feld je Abschnitt bei Bedarf auf Maß kürzen.');
        }
        s.push({ t: 'Felder montieren', p: montage });
      }

      var abschluss = ['Alles nochmal mit der Wasserwaage prüfen und Schrauben nachziehen.'];
      if (erg.kappenMoeglich && state.mitKappen) abschluss.push('Pfostenkappen aufsetzen.');
      s.push({ t: 'Abschluss', p: abschluss });
      return s;
    }

    function werkzeugliste(erg) {
      var b = state.befestigungId;
      var w = ['Maßband & Schnur', 'Wasserwaage', 'Akkuschrauber (Bits Torx/Kreuz)', 'Bleistift/Markierspray'];
      if (!erg.ohnePfosten && b === 'einbetonieren') w.push('Spaten oder Erdlochbohrer', 'Beton (erdfeucht) & Eimer');
      if (!erg.ohnePfosten && b === 'aufduebeln') w.push('Bohrmaschine mit Steinbohrer', 'Schlüssel für Schwerlastdübel');
      if (erg.lieferart === 'bausatz') w.push('Abstandslehre (z. B. Holzklotz)');
      w.push('Säge (falls das letzte Feld gekürzt wird)');
      return w;
    }

    /* Baut die komplette Druckseite als HTML-Dokument. */
    function anleitungHtml(erg) {
      var plan = pfostenPlan(erg);
      var details = erg.pfostenDetails || [];
      var url = location.href.split('#')[0] + hashAusState(state);
      var bild3d = '';
      try {
        var c3d = container.querySelector('#zk-3d-ergebnis');
        if (c3d) bild3d = '<img src="' + c3d.toDataURL('image/png') + '" alt="3D-Ansicht" style="width:100%;border-radius:8px;background:#eef3f7">';
      } catch (e) { /* Canvas nicht verfügbar – Anleitung geht auch ohne */ }

      var massketten = plan.map(function (a, i) {
        var zeilen = a.pfosten.map(function (pf) {
          var d = details[pf.nummer - 1];
          return '<tr><td>P' + pf.nummer + '</td><td class="z">' + formatMeter(pf.sCm) + '</td>' +
            '<td class="z">' + (d ? d.laengeCm + ' cm' + (d.extraCm > 0 ? ' (Stufe +' + d.extraCm + ' cm)' : '') : '–') + '</td></tr>';
        }).join('');
        return '<h3>Abschnitt ' + (i + 1) + ' (' + formatMeter(a.laengeCm) + ')</h3>' +
          '<p>Felder in dieser Reihenfolge: ' + a.felder.map(function (f) { return f + ' cm'; }).join(' · ') + '</p>' +
          '<table><thead><tr><th>Pfosten</th><th class="z">Position ab Abschnittsanfang</th><th class="z">Pfostenlänge</th></tr></thead>' +
          '<tbody>' + zeilen + '</tbody></table>';
      }).join('');

      var stueckliste = erg.positionen.map(function (p) {
        return '<tr><td>' + esc(p.bezeichnung) + '</td><td class="z">' + p.menge + '</td></tr>';
      }).join('');

      var schritte = montageSchritte(erg).map(function (s, i) {
        return '<h3>' + (i + 1) + '. ' + esc(s.t) + '</h3><ul>' +
          s.p.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
      }).join('');

      return '<!DOCTYPE html><html lang="de"><head><meta charset="utf-8">' +
        '<title>Aufbauanleitung – ' + esc(ZaunLogic.zusammenfassung(eingaben(), daten)) + '</title>' +
        '<style>' +
        'body{font-family:-apple-system,"Segoe UI",Roboto,Arial,sans-serif;color:#2b2b28;line-height:1.5;max-width:800px;margin:0 auto;padding:24px}' +
        'h1{font-size:1.5rem;margin:0 0 4px}h2{font-size:1.15rem;margin:26px 0 8px;border-bottom:2px solid #ddd8d0;padding-bottom:4px}' +
        'h3{font-size:1rem;margin:16px 0 6px}table{width:100%;border-collapse:collapse;font-size:0.92rem}' +
        'th,td{padding:5px 8px;border-bottom:1px solid #e5e0d8;text-align:left}td.z,th.z{text-align:right}' +
        '.leise{color:#6b675f;font-size:0.88rem}.banner{background:#fdf6e7;border:1px solid #ecd9a8;border-radius:8px;padding:10px 14px;font-size:0.88rem;margin:14px 0}' +
        '.drucken{background:#3f6b35;color:#fff;border:none;border-radius:8px;padding:10px 18px;font:inherit;cursor:pointer;margin:14px 0}' +
        'ul{margin:6px 0;padding-left:20px}a{color:#3f6b35;word-break:break-all}' +
        '@media print{.no-print{display:none}body{padding:0}}' +
        '</style></head><body>' +
        '<button class="drucken no-print" onclick="window.print()">Drucken / als PDF speichern</button>' +
        '<h1>Aufbauanleitung für deinen Zaun</h1>' +
        '<p class="leise">' + esc(ZaunLogic.zusammenfassung(eingaben(), daten)) + ' · erstellt am ' +
        new Date().toLocaleDateString('de-DE') + '</p>' +
        '<div class="banner">Vorläufige Fassung: Alle Angaben sind Richtwerte ohne Gewähr. ' +
        'Bei Fragen zur Montage ruf uns gern an – wir helfen weiter.</div>' +
        bild3d +
        '<h2>Dein Zaunverlauf (Draufsicht)</h2>' + planSvgFuerDruck(plan) +
        '<p class="leise">Braune Quadrate = Pfostenpositionen (P1, P2, …), S = Startpunkt.</p>' +
        '<h2>Maßkette: Wo kommt welcher Pfosten hin?</h2>' + massketten +
        '<h2>Stückliste</h2><table><thead><tr><th>Position</th><th class="z">Menge</th></tr></thead><tbody>' +
        stueckliste + '</tbody></table>' +
        '<h2>Schritt für Schritt</h2>' + schritte +
        '<h2>Werkzeug</h2><ul>' + werkzeugliste(erg).map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>' +
        (erg.hinweise.length ? '<h2>Gut zu wissen</h2><ul>' +
          erg.hinweise.map(function (h) { return '<li>' + esc(h) + '</li>'; }).join('') + '</ul>' : '') +
        '<h2>Konfiguration weiter bearbeiten</h2><p><a href="' + esc(url) + '">' + esc(url) + '</a></p>' +
        '</body></html>';
    }

    /*
     * Beim Hovern einer Karte wechseln die Fotos automatisch durch (statt
     * immer nur das erste zu zeigen); beim Verlassen zurück zum Startbild.
     */
    function fotoRotation(btn, bilder) {
      if (!bilder || bilder.length < 2) return;
      var img = btn.querySelector('.zk-karte-foto');
      if (!img) return;
      var startSrc = img.getAttribute('src');
      var idx = 0, timer = null;
      btn.addEventListener('mouseenter', function () {
        if (timer) return;
        timer = setInterval(function () {
          idx = (idx + 1) % bilder.length;
          img.src = bilder[idx];
        }, 1400);
      });
      btn.addEventListener('mouseleave', function () {
        if (timer) { clearInterval(timer); timer = null; }
        idx = 0;
        img.src = startSrc;
      });
    }

    function verdrahten() {
      planEditorVerdrahten();

      container.querySelectorAll('[data-modell]').forEach(function (btn) {
        var m = modelle.filter(function (mo) { return mo.id === btn.getAttribute('data-modell'); })[0];
        if (m) fotoRotation(btn, m.bilder);
      });
      container.querySelectorAll('[data-pfostensystem]').forEach(function (btn) {
        var s = (daten.pfostensysteme || []).filter(function (x) { return x.id === btn.getAttribute('data-pfostensystem'); })[0];
        if (s) fotoRotation(btn, s.bilder);
      });

      // 3D-Ansicht im Ergebnis-Schritt
      var canvasErg = container.querySelector('#zk-3d-ergebnis');
      if (canvasErg) {
        var ergebnis3d = ergebnis();
        if (ergebnis3d && ergebnis3d.ok) {
          var viewer = Zaun3D.erstelle(canvasErg);
          viewer.setzeSzene(planSzene(
            ergebnis3d.aufteilung.proSegment.map(expandiereFelder),
            ergebnis3d.ohnePfosten,
            ergebnis3d.pfostensystem
          ), !kameraMerker.ergebnis);
          if (kameraMerker.ergebnis) {
            viewer.kamera.theta = kameraMerker.ergebnis.theta;
            viewer.kamera.phi = kameraMerker.ergebnis.phi;
            viewer.kamera.dist = kameraMerker.ergebnis.dist;
            viewer.kamera.ziel = kameraMerker.ergebnis.ziel.slice();
            viewer.render();
          }
          kameraMerker.ergebnis = viewer.kamera;
        }
      }

      container.querySelectorAll('[data-lieferart]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.lieferartId = btn.getAttribute('data-lieferart');
          livePreiseGeladen = false; livePreise = {};
          render();
        });
      });

      container.querySelectorAll('[data-feldmodus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.feldmodus = btn.getAttribute('data-feldmodus');
          livePreiseGeladen = false; livePreise = {};
          render();
        });
      });

      container.querySelectorAll('[data-pfostensystem]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.pfostensystem = btn.getAttribute('data-pfostensystem');
          livePreiseGeladen = false; livePreise = {};
          render();
        });
      });

      // Foto-Galerie der Pfostensysteme (ohne das System auszuwählen)
      container.querySelectorAll('[data-fotos-system]').forEach(function (knopf) {
        knopf.addEventListener('click', function (e) {
          e.stopPropagation();
          var s = (daten.pfostensysteme || []).filter(function (x) { return x.id === knopf.getAttribute('data-fotos-system'); })[0];
          if (s) zeigeFotos(s);
        });
      });

      var massMax = container.querySelector('#zk-mass-max');
      if (massMax) massMax.addEventListener('change', function () {
        var min = parseInt(massMax.getAttribute('min'), 10) || 50;
        var max = parseInt(massMax.getAttribute('max'), 10) || 300;
        var wert = parseInt(massMax.value, 10);
        if (!wert) wert = (daten.massfeld && daten.massfeld.standard_max_cm) || 240;
        state.massMaxCm = Math.max(min, Math.min(max, wert));
        livePreiseGeladen = false; livePreise = {};
        render();
      });

      // Foto-Galerie öffnen, ohne das Modell auszuwählen (Knopf liegt in der Karte)
      container.querySelectorAll('[data-fotos]').forEach(function (knopf) {
        knopf.addEventListener('click', function (e) {
          e.stopPropagation();
          var m = modelle.filter(function (mo) { return mo.id === knopf.getAttribute('data-fotos'); })[0];
          if (m) zeigeFotos(m);
        });
      });

      container.querySelectorAll('[data-modell]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.modellId = btn.getAttribute('data-modell');
          // Höhe zurücksetzen, falls das neue Modell sie nicht anbietet
          var modell = modelle.filter(function (m) { return m.id === state.modellId; })[0];
          if (state.hoehe_cm && hoehenFuerModell(modell).indexOf(state.hoehe_cm) < 0) state.hoehe_cm = null;
          livePreiseGeladen = false; livePreise = {};
          state.schritt = 3;
          render();
        });
      });

      container.querySelectorAll('[data-hoehe]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.hoehe_cm = parseInt(btn.getAttribute('data-hoehe'), 10);
          // Höhen ohne Lager-Feld gibt es nur als "Felder nach Maß"
          if (btn.getAttribute('data-standard') === '0') state.feldmodus = 'mass';
          livePreiseGeladen = false; livePreise = {};
          state.schritt = 4;
          render();
        });
      });

      container.querySelectorAll('[data-befestigung]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.befestigungId = btn.getAttribute('data-befestigung');
          livePreiseGeladen = false; livePreise = {};
          state.schritt = 5;
          render();
        });
      });

      var weiter = container.querySelector('#zk-weiter');
      if (weiter) weiter.addEventListener('click', function () { state.schritt++; render(); });
      var zurueck = container.querySelector('#zk-zurueck');
      if (zurueck) zurueck.addEventListener('click', function () { state.schritt--; render(); });

      var kappen = container.querySelector('#zk-kappen');
      if (kappen) kappen.addEventListener('change', function () {
        state.mitKappen = kappen.checked;
        livePreiseGeladen = false; livePreise = {};
        render();
      });

      // Zubehör-Positionen abwählen (×) bzw. wieder hinzufügen
      container.querySelectorAll('[data-entfernen]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var typ = btn.getAttribute('data-entfernen');
          if (typ === 'kappe') state.mitKappen = false; // Kappen laufen über die eigene Checkbox
          else if (state.entfernt.indexOf(typ) < 0) state.entfernt.push(typ);
          livePreiseGeladen = false; livePreise = {};
          render();
        });
      });
      container.querySelectorAll('[data-hinzufuegen]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var typ = btn.getAttribute('data-hinzufuegen');
          state.entfernt = state.entfernt.filter(function (t) { return t !== typ; });
          livePreiseGeladen = false; livePreise = {};
          render();
        });
      });

      // Aufbauanleitung als druckfertige Seite in neuem Tab
      var anleitung = container.querySelector('#zk-anleitung');
      if (anleitung) anleitung.addEventListener('click', function () {
        var ergA = ergebnis();
        if (!ergA || !ergA.ok) return;
        var w = window.open('', '_blank');
        if (!w) {
          zeigeModal('<h3>Pop-up blockiert</h3><p>Bitte erlaube Pop-ups für diese Seite, um die Aufbauanleitung zu öffnen.</p>');
          return;
        }
        w.document.write(anleitungHtml(ergA));
        w.document.close();
      });

      // "Speichern": öffnet das Mailprogramm des Kunden mit vorbefülltem Link
      // an sich selbst – kein Server, kein SMTP nötig.
      var mail = container.querySelector('#zk-mail');
      if (mail) mail.addEventListener('click', function () {
        var url = location.href.split('#')[0] + hashAusState(state);
        var erg = ergebnis();
        var betreff = 'Deine Zaunplanung bei Zaunmaster';
        var text = 'Hallo!\n\n' +
          'Hier ist deine gespeicherte Zaunplanung:\n' +
          ZaunLogic.zusammenfassung(eingaben(), daten) +
          (erg && erg.ok ? ' – ca. ' + formatEuro(erg.summe) : '') + '\n\n' +
          'Weiter bearbeiten:\n' + url + '\n\n' +
          'Der Link öffnet den Zaunplaner genau mit diesem Stand – du kannst jederzeit weitermachen.\n\n' +
          'Viele Grüße\nDein Zaunmaster-Team';
        location.href = 'mailto:?subject=' + encodeURIComponent(betreff) + '&body=' + encodeURIComponent(text);
      });

      var teilen = container.querySelector('#zk-teilen');
      if (teilen) teilen.addEventListener('click', function () {
        var url = location.href.split('#')[0] + hashAusState(state);
        var fertig = function () {
          zeigeModal('<h3>Konfiguration teilen</h3><p>Der Link wurde in die Zwischenablage kopiert:</p><pre>' + esc(url) + '</pre>' +
            '<p>Damit kann jeder (auch am Telefon) genau diese Konfiguration öffnen.</p>');
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(fertig, fertig);
        } else { fertig(); }
      });

      var neustart = container.querySelector('#zk-neustart');
      if (neustart) neustart.addEventListener('click', function () {
        state = { schritt: 1, punkte: standardPunkte(), modellId: null, hoehe_cm: null,
          befestigungId: 'einbetonieren', lieferartId: 'vormontiert', mitKappen: false, geschlossen: false,
          feldmodus: 'standard', massMaxCm: null, pfostensystem: 'ipf', entfernt: [] };
        kameraMerker = { plan: null, ergebnis: null };
        livePreiseGeladen = false; livePreise = {};
        render();
      });

      var warenkorb = container.querySelector('#zk-warenkorb');
      if (warenkorb) warenkorb.addEventListener('click', function () {
        var erg = ergebnis();
        if (!erg || !erg.ok) return;
        var text = ZaunLogic.zusammenfassung(eingaben(), daten);
        var konfigId = 'ZK-' + Date.now().toString(36).toUpperCase();
        erg.positionen.forEach(function (p, i) {
          p.properties = { '_Konfiguration': konfigId };
          if (i === 0) p.properties['Konfiguration'] = text;
          if (p.massfeld) {
            // Maße ans Raster-Produkt hängen – so weiß die Fertigung, was gebaut wird.
            p.properties['Maßanfertigung'] = p.massfeld.modell + ', ' + p.massfeld.hoehe_cm + ' × ' + p.massfeld.laenge_cm + ' cm';
          }
          if (p.lieferart === 'bausatz') {
            // Bausatz läuft über das Raster-Produkt – ohne diese Eigenschaft
            // wüsste die Kommissionierung nicht, welches Feld gemeint ist
            // (und dass es unmontiert als Einzelteile geliefert wird).
            p.properties['Bausatz'] = p.bezeichnung;
          }
          if (p.konfiguratorFeld) {
            var kf = p.konfiguratorFeld;
            p.properties['_Konfigurator_Typ'] = kf.typ;
            p.properties['_Modell_ID'] = kf.modellId;
            p.properties['_Modell_DB'] = kf.modellDb;
            p.properties['_Laenge_cm'] = String(kf.laengeCm);
            p.properties['_Hoehe_cm'] = String(kf.hoeheCm);
            p.properties['_Lieferart'] = kf.lieferart;
            p.properties['_Regelversion'] = String(kf.regelversion);
            p.properties['_Latten_SKU'] = kf.lattenSku;
            p.properties['_Latten_Anzahl'] = String(kf.lattenAnzahl);
            p.properties['_Riegel_SKU'] = kf.riegelSku;
            p.properties['_Riegel_Anzahl'] = String(kf.riegelAnzahl);
            p.properties['_Schrauben_Anzahl'] = String(kf.schraubenAnzahl);
            p.properties['_Montage'] = kf.montage ? 'ja' : 'nein';
          }
        });
        warenkorb.disabled = true;
        warenkorb.textContent = 'Wird hinzugefügt …';
        adapter.addToCart(erg.positionen, { zusammenfassung: text, konfigId: konfigId, summe: erg.summe })
          .catch(function (err) {
            zeigeModal('<h3>Das hat leider nicht geklappt</h3><p>' + esc(err && err.message || err) +
              '</p><p>Bitte versuche es noch einmal oder ruf uns an.</p>');
          })
          .then(function () {
            warenkorb.disabled = false;
            warenkorb.textContent = 'Alles in den Warenkorb';
          });
      });
    }

    render();
  }

  // skizzeBefestigung wird zusätzlich exportiert, damit der Regel-Editor
  // (regel_editor/) dieselben Befestigungs-Skizzen als Vorschau zeigen kann.
  window.ZaunKonfigurator = { init: init, skizzeBefestigung: skizzeBefestigung };
}());
